import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}]]

const IconTallymark1 = createReactComponent('outline', 'tallymark-1', 'Tallymark1', __iconNode);

export default IconTallymark1;